const flattenToDotNotation = (obj, prefix = '') => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        const fullKey = prefix ? `${prefix}.${key}` : key;

        if (typeof value === 'object') {
            Object.assign(acc, flattenToDotNotation(value, fullKey));
        } else {
            acc[fullKey] = value;
        }

        return acc;
    }, {});
};

export default flattenToDotNotation;
